"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useEffect, useRef, useState } from "react";
export default function ServicesIntroduction() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const imageRef = useRef<HTMLDivElement>(null);
  const [mousePosition, setMousePosition] = useState({
    x: 0,
    y: 0
  });
  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      const x = (e.clientX / window.innerWidth - 0.5) * 20;
      const y = (e.clientY / window.innerHeight - 0.5) * 20;
      setMousePosition({
        x,
        y
      });
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);
  return <section ref={sectionRef} className="relative w-full bg-background py-24 px-4 overflow-hidden">
			<div className="max-w-4xl mx-auto">
				{}
				<div className={`text-center mb-6 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
					<h1 className="text-5xl md:text-6xl font-sans font-bold text-foreground leading-tight">
						Innovate with Confidence
					</h1>
				</div>

				{}
				<div className={`text-center mb-12 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] delay-100 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
					<p className="text-lg md:text-xl text-muted leading-relaxed max-w-3xl mx-auto">We provide integrated product, technical, and strategic expertise to help companies develop new products, strengthen existing lines, and make informed decisions throughout the innovation and commercialization lifecycle.</p>
				</div>

				{}
				<div ref={imageRef} className={`relative transition-all duration-500 ease-[var(--ease-smooth)] delay-200 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
        transform: isVisible ? `translate(${mousePosition.x * 0.5}px, ${mousePosition.y * 0.5}px)` : "translate(0, 0)",
        transition: "transform 0.5s ease-out, opacity 0.5s ease-out"
      }}>
					<div className="relative mx-auto max-w-2xl">
						<div className="absolute inset-0 bg-primary/10 rounded-lg blur-3xl" style={{
            transform: "translateY(10px)"
          }} />
						<img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1475438/img/innovation_lab_workspace.png" alt="Innovative product development workspace showcasing advanced materials and prototyping" className="relative w-full h-auto rounded-lg shadow-strong" style={{
            transform: "translateY(-10px)"
          }} />
					</div>
				</div>
			</div>
		</section>;
}